import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {FormMappersFactory} from '../../form/Mappers/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {DraftServicesFactory} from '../Services/factory.js'

export class ObtainDraftAdPublisherUseCase extends UseCase {
  #getCurrentUserService
  #ongoingDraftService
  #fromDraftEntityToDraftFormValueObjectMapper

  constructor({config}) {
    super()

    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({
      config
    })
    this.#ongoingDraftService = DraftServicesFactory.ongoingDraftService({config})
    this.#fromDraftEntityToDraftFormValueObjectMapper = FormMappersFactory.fromDraftEntityToDraftFormValueObject({
      config
    })
  }

  static create({config}) {
    return new ObtainDraftAdPublisherUseCase({config})
  }

  @tracer({metric: 'ObtainDraftAdPublisherUseCase#execute'})
  @inlineError
  async execute({categoryId} = {}) {
    const userEntity = await this.#getCurrentUserService.execute()

    const [ongoingError, ongoingResponse] = await this.#ongoingDraftService.execute({
      categoryId,
      userEntity
    })

    if (ongoingError) return Promise.reject(ongoingError)

    const {status, data} = ongoingResponse.toJSON()

    return {
      status,
      data: this.#fromDraftEntityToDraftFormValueObjectMapper
        .setParams({
          ...data
        })
        .map()
        .toJSON()
    }
  }
}

export const factory = ObtainDraftAdPublisherUseCase.create
